// extracted by mini-css-extract-plugin
module.exports = {"spinner":"CursorLoadingSpinner_spinner__45AWM","spin":"CursorLoadingSpinner_spin__ppWl1"};